export default function (value) {
    const map = {
        EUR: '€',
        USR: '$',
    };

    return map[value] ?? value;
}
